import React from 'react';
import PropTypes from 'prop-types';

import Grid from '../../../components/Grid';
import Accordion from '../../../components/Accordion';

const Slopes = (props) => {
  const slopesData = props.slopes;

  const slopes = slopesData.map((slope) => {
    return {
      title: (
        <Grid
          className="title"
          columns={[
            <div
              key="name"
              className={`icon difficulty difficulty--${slope.difficulty.level}`}
            >
              <p>{slope.name}</p>
            </div>,
            <p key="level">{slope.difficulty.name}</p>,
            <div key="info" className="info">
              <p className="status">
                {slope.open_today ? (
                  <>
                    {Drupal.t('Open', {}, { context: 'Opening hours' })}{' '}
                    {slope.open_today}
                  </>
                ) : (
                  Drupal.t('Closed')
                )}
              </p>
              <p>{slope.info}</p>
            </div>,
          ]}
        />
      ),
      content: (
        <Grid
          columns={[
            <div key="open" className="opening-hours">
              <p className="opening-hours-title">{Drupal.t('Opening hours')}</p>
              {slope.opening_hours.map((opening, i) => (
                <p key={i} className="opening-times">
                  {Drupal.t(opening.weekday)} {opening.opens}
                </p>
              ))}
            </div>,
            <div key="2"></div>,
            <div key="3">
              {slope.snow && `${Drupal.t('Snowmaking')}: ${slope.snow}%`}
            </div>,
          ]}
        />
      ),
    };
  });

  return (
    <div className="slopes">
      <h3>
        {props.slopes.length}{' '}
        {props.season === 'winter'
          ? Drupal.t('slopes', {}, { context: 'count' })
          : Drupal.t('routes', {}, { context: 'count' })}
      </h3>
      <Grid
        className="heading"
        columns={[
          <strong key="column-1">{Drupal.t('Name')}</strong>,
          <strong key="column-2">
            {props.season === 'winter' ? Drupal.t('Level') : Drupal.t('Trail type')}
          </strong>,
          <strong key="column-3">{Drupal.t('Opening hours')}</strong>,
        ]}
      />
      <div className="accordion-list">
        {slopesData && slopesData.length > 0 ? (
          slopes.map((slope, i) => (
            <div key={i} className="accordion-list__item">
              <Accordion title={slope.title} content={slope.content} />
            </div>
          ))
        ) : (
          <h3>{Drupal.t('Slope info not available.')}</h3>
        )}
      </div>
    </div>
  );
};

Slopes.propTypes = {
  slopes: PropTypes.array,
  season: PropTypes.string,
};

export default Slopes;
